/**
 * Company: SPHMedia
 * Description: [Short form video block component for video page scrolling]
 */

import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import { Heading } from "@sphtech/sph-web-ui";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import Cookies from "js-cookie";
import { ReactElement, useCallback } from "react";

type ShortFormVideoBlockProps = {
  videos: LatestVideoResponse[];
};

/**
 * ShortFormVideoBlock
 * Description: [Short form video block component for video page scrolling]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ShortFormVideoBlock({
  videos,
}: ShortFormVideoBlockProps): ReactElement {
  const handleOnClickThumbnail = useCallback((video: LatestVideoResponse) => {
    const qs = new URLSearchParams({ ref: "videos" }).toString();
    Cookies.set("qnRedirectUrl", encodeURIComponent(window.location.href));
    window.open(
      `/quick-news/video/${video.id}?${qs}`,
      "_blank",
      "noopener,noreferrer",
    );
  }, []);

  return (
    <>
      <div className="flex flex-col items-center gap-2.5 py-4 bg-[#EDECEE] -mt-5 px-[15px]">
        <div className="flex flex-col gap-2.5 w-full">
          <div className="h-0.5 bg-brand-primary"></div>
          <Heading
            Element="h2"
            className="text-brand-primary text-sm font-semibold font-primary leading-[150%] py-1"
          >
            Ringkas
          </Heading>
        </div>

        <div className="w-full max-w-[815px]">
          <div className="grid grid-cols-2 gap-y-[11px] gap-x-3">
            {videos.map((video, index) => (
              <ThumbnailCard<LatestVideoResponse>
                key={`thumbnail-${video.id}`}
                testId={`video-short-form-block-${index}`}
                handleOnClickThumbnail={handleOnClickThumbnail}
                variant="short_form_video_block"
                {...video}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
